<template>
  <div class="chat-window" @keydown.escape="$emit('close')">
    <div class="header">
      <slot name="header"></slot>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss" scoped>
$chat-fab-with-margin: calc(#{var(--chat-size)} + #{var(--spacing-200)});
$chat-window-bottom-position: calc(
  #{$chat-fab-with-margin} + #{var(--bottombar-height)} + #{var(--spacing-100)}
);

.chat-window {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 24rem;
  height: 55rem;
  max-height: 65vh;
  max-width: 90%;
  position: fixed;
  bottom: $chat-window-bottom-position;
  right: var(--spacing-150);
  box-shadow: var(--shadow-2);
  border-radius: var(--radius-large);
  z-index: $z-modal -1;

  @media only screen and (max-width: $md) {
    right: var(--spacing-100);
  }

  @media only screen and (max-width: $xs), (max-height: $xs) and (orientation: landscape) {
    bottom: 0;
    width: 100%;
    max-width: 100%;
    right: 0;
    border-radius: var(--radius-large) var(--radius-large) 0 0;
    max-height: 95%;
    height: 95%;
  }

  .header {
    width: 100%;

    @media screen and (max-width: $sm) {
      z-index: $z-base * 10;
    }
  }

  .content {
    background-color: var(--white);
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .actions {
    background-color: var(--white);
    width: 100%;
    height: 8rem;
  }
}
</style>
